module.exports = __webpack_public_path__ + "static/media/bg1.4c07214d.jpg";